import Vue from 'vue';
import Resource from 'vue-resource';
import IdleVue from 'idle-vue';
import VueTheMask from 'vue-the-mask';
import { sync } from 'vuex-router-sync';
import VueTouch from 'vue-touch';
import VeeValidate from 'vee-validate';
import router from './router';
import store from './store/store';
import filters from './helpers/filters';
import env from './config/env';
import Logger from './plugins/logger';
import EventBus from './event-bus';
import { createProvider } from './vue-apollo';
import App from './App.vue';
import { emitter } from './store/modules/Revista/user.store';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueNotice from '@marcius-studio/vue-notice';

// import vOutsideEvents from 'vue-outside-events';
const sentryConfig = process.env.VUE_APP_SENTRY_DSN;

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: sentryConfig,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

const optionsIdle = {
  eventEmitter: EventBus,
  store,
  moduleName: env.idle.name,
  idleTime: env.idle.time,
  events: env.idle.events,
  keepTracking: true,
  startAtIdle: true,
};

Vue.config.productionTip = false;
Vue.use(Resource);
Vue.use(IdleVue, optionsIdle);
Vue.use(VueTouch);
// Vue.use(vOutsideEvents);
Vue.use(VeeValidate);
Vue.use(VueTheMask);

Vue.use(VueNotice, {
  layout: 'centerRight',
  theme: 'mint',
  timeout: 5000,
  progressBar: true,
});

// Vue.use(VueAnalytics, {
//   id: env.GA,
//   router,
//   ignoreRoutes: ['/login', '/404'],
//   debug: {
//     enabled: false,
//     trace: true,
//     sendHitTask: true,
//   },
//   autoTracking: {
//     pageviewTemplate(route) {
//       return {
//         title: document.title,
//         page: route.path,
//         location: window.location.href,
//       };
//     },
//   },
//   set: [
//     { field: 'UF', value: env.revista.uf },
//     { field: 'Canal', value: getCanal(env.revista.canal) },
//   ],
// });
/**
 * Sync Vuex + Router
 */
sync(store, router);

// Filters
let filter;
for (filter in filters) {
  Vue.filter(filter, filters[filter]);
}
// Corrigir isso futuramente
// Criar um arquivo de configurações ou services para instanciar os localStorage
window.$modulo = env.revista.modulo;

// Loggers
Vue.use(Logger, {
  env,
  router,
  emitter,
  store,
  options: { log: ['Revista'] },
  EventBus,
});

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
